<template>
    <div component="AdminMenuList">
        <v-list>
            <admin-menu-list-item
                v-for="(item, index) in admin_navigation"
                :item="item"
                :key="`admin-menu-child-item-${index}`"
            />
        </v-list>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AdminMenuListItem from '@/components/Admin/AdminMenuListItem.vue';

export default {
    name: 'AdminMenuList',

    props: {},

    computed: {
        ...mapGetters({
            admin_navigation: 'getAdminNavigationMenu',
        }),
    },

    mounted() {},

    components: {
        AdminMenuListItem,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='AdminMenuList'] {
    .v-list {
        background: transparent;
    }

    .v-list-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: auto;
    }
}
</style>
